import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { OfficeBenefits } from './OfficeBenefits';
import { RestoBenefits } from './RestoBenefits';
import { NightclubBenefits } from './NightclubBenefits';

export const ThemeAwareBenefits: React.FC = () => {
  const { theme } = useTheme();
  
  if (theme === 'nightclub') return <NightclubBenefits />;
  if (theme === 'resto') return <RestoBenefits />;
  return <OfficeBenefits />;
};